import React from 'react';
import { useDocumentInteractStart, useInteractMedia } from 'Hooks/Document';

import { BaseInteractModalProps } from './common/interfaces';
import {
  BaseInteractModalDesktop,
  BaseInteractModalMobile,
  BaseInteractModalTablet,
} from './components/Breakpoints';

export function BaseInteractModal(props: BaseInteractModalProps) {
  const { enableFullscreen = false, ...restProps } = props;

  const [isExtraMobile, isMedium, isTablet] = useInteractMedia(['xs', 'md', 'lg']);
  const isDocumentInteractLoading = useDocumentInteractStart(props.documentId);

  if (isExtraMobile) {
    return (
      <BaseInteractModalMobile
        {...restProps}
        enableFullscreen={enableFullscreen}
        isDocumentInteractLoading={isDocumentInteractLoading}
      />
    );
  }

  if (isMedium || isTablet) {
    return (
      <BaseInteractModalTablet
        {...restProps}
        enableFullscreen={enableFullscreen}
        isDocumentInteractLoading={isDocumentInteractLoading}
      />
    );
  }

  return (
    <BaseInteractModalDesktop
      {...restProps}
      enableFullscreen={enableFullscreen}
      isDocumentInteractLoading={isDocumentInteractLoading}
    />
  );
}

export default BaseInteractModal;
